import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { VacanciesFetchError } from '../../../shared/errors';
import { ESubdomain } from '../../constants/domain';
import {
  fetchFilterVacancies,
  IFilterVacanciesResponse200,
  IFilterVacanciesResponse400,
} from '../../repositories/vacancies/v1/filter-vacancies';
import { IFilterParams } from '../../types/IFilterParams';

export interface IGetVacanciesDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
  subdomain: ESubdomain;
}

export interface IGetVacanciesParams {
  filter: IFilterParams;
}

export const getVacancies = async (deps: IGetVacanciesDependencies, params: IGetVacanciesParams) => {
  const { httpApi, logger, subdomain } = deps;
  const { filter } = params;

  try {
    const resp = await fetchFilterVacancies<IFilterVacanciesResponse200, IFilterVacanciesResponse400>({
      httpApi,
      parameters: { ...filter },
    });

    if (resp.statusCode !== 200) {
      throw new VacanciesFetchError({
        subdomain,
        message: resp.response.message,
        details: {
          error: JSON.stringify(resp.response.errors),
        },
      });
    }

    return resp.response;
  } catch (e) {
    logger.error(e);

    throw e;
  }
};
